var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewReadingListSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "save_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.37,
    height: 39.37,
    viewBox: "0 0 39.37 39.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16655",
    "data-name": "Path 16655",
    d: "M0,0H39.37V39.37H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16656",
    "data-name": "Path 16656",
    d: "M29.247,17.764V29.247H6.281V17.764H3V29.247a3.29,3.29,0,0,0,3.281,3.281H29.247a3.29,3.29,0,0,0,3.281-3.281V17.764Zm-9.843,1.1,4.249-4.232,2.313,2.313-8.2,8.2-8.2-8.2,2.313-2.313,4.249,4.232V3H19.4Z",
    transform: "translate(1.921 1.921)",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReadingListSaveIcon);
export default __webpack_public_path__ + "static/media/view-reading-list-save-icon.7b56610ed33381f76612d64e4e1d8a21.svg";
export { ForwardRef as ReactComponent };